// import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
var Forms = function Forms(_ref) {
  var _popup$files;
  var popupID = _ref.popupID;
  var popup = useSelector(function (s) {
    return s.popups[popupID] || {};
  });
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });

  // const [pageContent, setPageContent] = useState([]);
  // const api = useSelector(s => s.config.api);

  // useEffect(() => {
  // 	axios
  // 		.get(`${api}/api/ArticlePageExForm/`)
  // 		.then(res => {
  // 			if (res?.data && Array.isArray(res.data))
  // 				setPageContent(res.data);
  // 		});
  // }, []);

  // console.log('popupID', popupID)
  // console.log('popup', popup)

  return /*#__PURE__*/React.createElement("div", {
    className: "popup"
  }, /*#__PURE__*/React.createElement("div", {
    className: "a__title popup__title"
  }, /*#__PURE__*/React.createElement("h1", null, popup === null || popup === void 0 ? void 0 : popup.title)), (popup === null || popup === void 0 ? void 0 : popup.subtitle) && /*#__PURE__*/React.createElement("div", {
    className: "a__subtitle forms__site"
  }, /*#__PURE__*/React.createElement("h4", null, popup === null || popup === void 0 ? void 0 : popup.subtitle)), popup === null || popup === void 0 ? void 0 : (_popup$files = popup.files) === null || _popup$files === void 0 ? void 0 : _popup$files.map(function (x) {
    return /*#__PURE__*/React.createElement("div", {
      className: "popup__row",
      key: 'form_' + x._id
    }, /*#__PURE__*/React.createElement("img", {
      src: "/public/images/pdf-icon.png"
    }), /*#__PURE__*/React.createElement("div", {
      className: "popup__row--title",
      onClick: function onClick() {
        return window.open(bucket + '/' + x.assetID.filename, '_blank');
      }
    }, x.title));
  }), (popup === null || popup === void 0 ? void 0 : popup.type) === 'text' && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: popup.paragraph
    },
    className: "a__paragraph"
  }));
};
export default Forms;